export default {
      id: "Icon--photo-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--photo",
      toString: function () {
        return this.url;
      }
    }